/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserOperationResponseResource
 */
export interface UserOperationResponseResource {
    /**
     * 
     * @type {string}
     * @memberof UserOperationResponseResource
     */
    id?: string;
}

/**
 * Check if a given object implements the UserOperationResponseResource interface.
 */
export function instanceOfUserOperationResponseResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserOperationResponseResourceFromJSON(json: any): UserOperationResponseResource {
    return UserOperationResponseResourceFromJSONTyped(json, false);
}

export function UserOperationResponseResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserOperationResponseResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function UserOperationResponseResourceToJSON(value?: UserOperationResponseResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

